<template>
  <div class="ask-show-comment">
    <van-nav-bar
    v-if="source==1&&pageLength>1"
    title="评论详情"
    left-arrow
    :fixed="true"
    @click-left="onClickLeft"
    />
    <van-nav-bar
    v-if="source==1&&pageLength==1"
    title="评论详情"
    :fixed="true"
    @click-left="onClickLeft">
    <template #left>
      <van-icon name="wap-home-o" size="18" />
    </template>
  </van-nav-bar>
  <div class="comment" :style="{'margin-top':source==1?'50px':'0'}" v-if="info">
    <van-row class="list" gutter="15">
      <van-col span="3">
        <img class="avatar" :src="info.user && info.user.headimg_url ? info.user.headimg_url : img.avatar" />
      </van-col>
      <van-col span="21">
        <h3>
          {{ info.user.user_name }}
          <span class="binbox">
            <img class="binpic" @click="setCommentPraise" :src="info.is_praise ? img.parise_have : img.parise">
            <span class="sourtime">{{ info.praise_num }}</span>
          </span>
        </h3>
        <p v-if="info.content">{{ info.content }}</p>
        <van-row type="flex" justify="space-between">
          <van-col span="14">
            <span class="time">{{ info.create_time }}<span>回复({{ info.reply_num }})</span></span>
          </van-col>
          <van-col class="bintright" span="10">
            <span class="sourtime" @click="toTip">举报</span>
          </van-col>
        </van-row>
      </van-col>
    </van-row>
  </div>
  <div class="replys">
    <van-list
    v-model="loading"
    :finished="finished"
    finished-text="没有更多了"
    @load="onLoad"
    >
    <div slot="loading" class="list-loading">
      <img :src="this.img.loading" />
      <span>正在刷新</span>
    </div>
    <div class="reply">
      <van-row class="list" gutter="15" v-for="(reply, index) in replys" :key="'reply_' + reply.id">
        <van-col span="3">
          <img class="avatar" :src="reply.user && reply.user.headimg_url ? reply.user.headimg_url : img.avatar" />
        </van-col>
        <van-col span="21">
          <h3>
            {{ reply.user.user_name }}
            <span class="binbox">
              <img class="binpic" @click="setReplyPraise(index)" :src="reply.is_praise ? img.parise_have : img.parise">
              <span class="sourtime">{{ reply.praise_num }}</span>
            </span>
          </h3>
          <p v-if="reply.content"><span v-if="reply.reuser">回复<span class="c-blue">{{ reply.reuser.user_name }}</span>：</span>{{ reply.content }}</p>
          <van-row type="flex" justify="space-between">
            <van-col span="14">
              <span class="time">{{ reply.create_time }}
                <span class="c-black" @click="replysd(reply.id)"> · 回复
                  <span v-if="reply.replys">({{ reply.reply_num }})
                  </span>
                </span>
              </span>
            </van-col>
            <van-col class="bintright" span="10">
              <span class="sourtime" @click="toTip">举报</span>
            </van-col>
          </van-row>
        </van-col>
      </van-row>
    </div>
  </van-list>
</div>
<div @touchstart="touchstart()" class="postoverlay" v-show="overlay"></div>
<div class="postbottom" id="inputid">
  <van-row>
    <van-col :span="inputnum">
      <van-field v-model="value" @click="inputFocus()" :focus="inputfocus" placeholder="发表评论..." ref="inputTag" />
    </van-col>
    <van-col  v-if="inputshow" class="botright" span="10">
      <van-row>
        <van-col span="8"> 
          <span class="binbox">
            <img class="binpic" :src="img.comment">
            <span class="num" v-if="info.reply_num>0">{{info.reply_num}}</span>
          </span>
        </van-col>
        <van-col span="10">
          <span class="binbox" @click="Collect(answerinfo.answer.is_collect)">
            <img class="binpic" :src="answerinfo.answer.is_collect==1?img.collect_have:img.collect">
            <span class="num" v-if="answerinfo.collect_num>0">{{answerinfo.collect_num}}</span>
          </span>
        </van-col>
        <van-col span="6">
          <span class="binbox" @click="outrelay(answerinfo.question,answerinfo.content,'/ask/'+answerinfo.answer.id+'/answer',answerinfo.image[0])">
            <img class="binpic" :src="img.outrelay">
          </span>
        </van-col>
      </van-row>
    </van-col>
    <van-col v-else span="5">
      <van-button color="#F6AB00" size="small" @click="post()">发表</van-button>
    </van-col>
  </van-row>
</div>
<van-action-sheet v-model="shareshow" :round="false" cancel-text="取消" @cancel="onCancel">
  <van-divider class="divider">分享</van-divider>
  <van-grid :border='false' :column-num="2">
    <van-grid-item :icon="img.friends" @click="toShare(2)" />
    <van-grid-item :icon="img.wechat" @click="toShare(1)" />
  </van-grid>
</van-action-sheet>
</div>
</template>

<script>
  import ask from '../../../api/ask';
  import { mapState } from 'vuex';
  import {Row, Col, Tag,NavBar,Grid, GridItem,List,Field,Button,Overlay,ActionSheet,Divider,Icon } from "vant";

  export default {
    data () {
      return {
        params: {
          page: 1,
          size: 4,
          order: 1,
          user_id: 0
        },
        comment_id: 0,
        loading: false,
        finished: false,
        info: '',
        answerinfo:'',
        replys: [],
        value:'',
        inputshow:true,
        overlay:false,
        inputfocus:false,
        inputnum:14,
        rid:'',
        shareshow:false,
        pageLength:1,
        img: {
          avatar: require('../../../assets/img/default.jpg'),
          parise: require('../../../assets/img/parise.png'),
          parise_have: require('../../../assets/img/parise_have.png'),
          loading: require('../../../assets/img/loading.gif'),
          collect: require('../../../assets/img/collect.png'),
          collect_have: require('../../../assets/img/collect_have.png'),
          comment: require('../../../assets/img/lexus/comment.png'),
          outrelay: require('../../../assets/img/lexus/outrelay.png'),
          friends: require('../../../assets/img/friend.png'),
          wechat: require('../../../assets/img/wecheck.png'),
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.pageLength=window.history.length
      this.weburl=process.env.VUE_APP_URL
      if(this.source == 3||this.source == 7) {
        this.$appService.isShowReturn({state: true})
      }

      this.$store.commit('param/show', false)
      let id = this.$route.params.id
      this.answer_id=this.$route.params.answerid
      if(this.$util.isEmpty(id)) {
        this.$toast('评论不存在')
        return false
      }
      this.comment_id = id

      this.getInfo()
      this.getAnswerShow()
    },
    watch: {
      '$route'() {
        if(this.$route.params.id != this.comment_id) {
          this.comment_id = this.$route.params.id
          this.answer_id=this.$route.params.answerid
          this.getInfo()
          this.getAnswerShow()
        }
      }
    },
    methods: {
      setCommentPraise () {
        if(this.source == 3||this.source == 7) {
          this.$appService.getToken(v => {
            if(v.token) {
              this.$store.dispatch('param/setToken', v.token)
            } else {
             var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        }else if(this.source == 1){
          if(localStorage.getItem('token')){
            this.token=true
          }else{
            this.getAuthorization.getAuthorization();
          }
        }

        if(this.user) {
          let type = this.info.is_praise ? 2 : 1;
          ask.setCommentPraise({id: this.info.id, type: type}).then(res => {
            if(res.data.state == 1) {
              if(type == 1) {
                this.info.is_praise = 1
                // this.$toast.success('点赞成功')
              } else {
                this.info.is_praise = 0
                // this.$toast.success('取消成功')
              }
            }
          })
        } else {
          this.$toast('请先登录')
          return false
        }

      },
      setReplyPraise (index) {
        if(this.source == 3||this.source == 7) {
          this.$appService.getToken(v => {
            if(v.token) {
              this.$store.dispatch('param/setToken', v.token)
            } else {
             var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        }else if(this.source == 1){
          if(localStorage.getItem('token')){
            this.token=true
          }else{
            this.getAuthorization.getAuthorization();
          }
        }

        if(this.user) {
          let type = this.replys[index].is_praise ? 2 : 1;
          ask.setCommentPraise({id: this.replys[index].id, type: type}).then(res => {
            if(res.data.state == 1) {
              if(type == 1) {
                this.replys[index].is_praise = 1
                this.replys[index].praise_num += 1
                // this.$toast.success('点赞成功')
              } else {
                this.replys[index].is_praise = 0
                this.replys[index].praise_num -= 1
                // this.$toast.success('取消成功')
              }
            }
          })
        } else {
          this.$toast('请先登录')
          return false
        }

      },
      toTip() {
        this.$toast.success('举报成功')
      },
      getInfo () {
        let user_id = this.user ? this.user.id : 0
        ask.getCommentShow(this.comment_id, {user_id: user_id}).then(res => {
          if(res.data.state == 1) {
            this.info = res.data.data
          }
        })
      },
      getAnswerShow(){
        let user_id = this.user ? this.user.id : 0
        ask.getAnswerShow(this.answer_id, {user_id: user_id}).then(res => {
          if(res.data.state == 1) {
            this.answerinfo = res.data.data
          }
        })
      },
      onClickLeft(){
        if(this.pageLength==1){
          this.$router.push({name:'Home'});
        }else{
          this.$router.go(-1)
        }
      },
  inputFocus(){//点击输入框聚焦
    if(this.source == 3||this.source == 7) {
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
         var params={
          url:'',
          pagetype:0
        }
        this.$appService.needLogin(params)
      }
    })
    }else if(this.source == 1){
      if(localStorage.getItem('token')){
        this.token=true
      }else{
        this.getAuthorization.getAuthorization();
      }
    }
    this.inputshow=false;
    this.overlay=true;
    this.inputnum=19;
    setTimeout(() => {
      var cc=document.getElementById('inputid');
      cc.scrollIntoViewIfNeeded(true);
    },500);
  },
  replysd(rid){
    if(this.source == 3||this.source == 7) {
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
         var params={
          url:'',
          pagetype:0
        }
        this.$appService.needLogin(params)
      }
    })
    }else if(this.source == 1){
      if(localStorage.getItem('token')){
        this.token=true
      }else{
        this.getAuthorization.getAuthorization();
      }
    }
    this.inputshow=false;
    this.overlay=true;
    this.inputnum=19;
    this.inputfocus=true
    this.$refs.inputTag.focus()
    this.rid=rid
    setTimeout(() => {
      var cc=document.getElementById('inputid');
      cc.scrollIntoViewIfNeeded(true);
    },500);
  },
      touchstart(){//检测触发遮罩层，失去焦点
        this.inputshow=true;
        this.overlay=false;
        this.$refs.inputTag.blur()
        this.inputnum=14;
        this.inputfocus=false
      },
      inputBlur(){//点击失去焦点
        setTimeout(() => {
          this.inputshow=true;
          this.inputnum=14;
        }, 1000);
        this.overlay=false;
        this.inputfocus=false
        this.$refs.inputTag.blur()
      },
      post(){
        let params={
          rid:this.rid,
          parent_rid:this.comment_id,
          answer_id:this.answer_id,
          content:this.value
        }
        ask.Comment(params).then(res => {
         if(res.data.state == 1) {
          this.inputshow=true;
          this.inputnum=14;
          this.overlay=false;
          this.inputfocus=false
          this.$refs.inputTag.blur()
          this.$toast.success('发表成功')
          this.value=''
          this.finished = false
          this.comments=[]
          this.params.page = 1
        }
      })
      },
      Collect(type){
        if(this.source == 3||this.source == 7) {
          this.$appService.getToken(v => {
            if(v.token) {
              this.$store.dispatch('param/setToken', v.token)
            } else {
             var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        }else if(this.source == 1){
          if(localStorage.getItem('token')){
            this.token=true
          }else{
            this.getAuthorization.getAuthorization();
          }
        }
        var param={
          id:this.answerinfo.answer.id,
          type: type==1?2:1
        }
        ask.Collect(param).then(res => {
          if(res.data.state == 1) {
            if(param.type == 1) {
              this.answerinfo.answer.is_collect = 1
              this.answerinfo.collect += 1
            } else {
              this.answerinfo.answer.is_collect = 0
              this.answerinfo.collect -= 1
            }
          }
        })
      },
      delComment(id,index){
        if(this.source == 3||this.source == 7) {
          this.$appService.getToken(v => {
            if(v.token) {
              this.$store.dispatch('param/setToken', v.token)
            } else {
             var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        }else if(this.source == 1){
          if(localStorage.getItem('token')){
            this.token=true
          }else{
            this.getAuthorization.getAuthorization();
          }
        }
        this.$dialog.confirm({
          message: '确定要删除吗？'
        }).then(() => {
         ask.delComment(id).then(res => {
          if(res.data.state == 1) {
            this.$toast.success('已删除')
            this.comments.splice(index,1);
          }
        })
       }).catch(() => {});
      },
      onCancel(){
        this.actionshow=false
      },
      outrelay(title,content,url,imageUrl){
        this.shareshow=true
        this.sharetitle=title
        this.sharecontent=content
        this.shareurl=this.weburl+url
        if(imageUrl){
          this.shareimageUrl=imageUrl
        }else{
          this.shareimageUrl='https://pic.motortime.com/logo/motortime_logo.png'
        }
        
      },
      toShare(type){
        var params={
          type:type,
          title:this.sharetitle,
          content:this.sharecontent,
          url:this.shareurl,
          imageUrl:this.shareimageUrl
        }
        this.shareshow=false
        this.$appService.shareContent(params)
      },
      onLoad() {
        this.params.user_id = this.user ? this.user.id : 0
      // 异步更新数据
      setTimeout(() => {
        ask.getCommentReplys(this.comment_id, this.params).then(res => {
          this.replys.push.apply(this.replys, res.data.data.data)
          this.params.page += 1
          this.loading = false

          if(res.data.data.data.length == 0) {
            this.finished = true
          }
        })
      }, 500);
    }
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Tag.name]: Tag,
    [NavBar.name]:NavBar,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [List.name]:List,
    [Field.name]:Field,
    [Button.name]:Button,
    [Overlay.name]:Overlay,
    [ActionSheet.name]:ActionSheet,
    [Divider.name]:Divider,
    [Icon.name]:Icon,
  }
};
</script>

<style lang="scss">
  .ask-show-comment {
    background-color: #F0F0F0;
  // .van-nav-bar__left {
  //  left: 10px;
  // }
  .comment {
    padding: 0 10px;
    background-color: #FFF;
  }
  .replys {
    margin-top: 10px;

    .reply {
      margin: 0 10px;
      overflow: hidden;
    }
    
  }
  .sourtime{
    font-size: 12px;
    color: #9A9A9A;
  }
  .list {
    border-bottom: 1px solid #EAEAEA;
    padding: 10px 0;
  }
  .avatar {
    width: 100%;
    height: auto;
    object-fit: cover;
    border-radius: 15px;
  }
  h3 {
    font-size: 15px;
    margin: 0;

    .binbox {
      color: #9A9A9A;
      font-size: 12px;
      float: right;
      font-weight: normal;

      img {
        width: 15px;
        height: 14px;
        margin-right: 11px;
        vertical-align: middle;
      }
    }
  }
  p {
    font-size: 15px;
    margin: 5px 0;

    .c-blue {
      font-style: normal;
    }
  }
  .time {
    font-size: 12px;
    color: #9A9A9A;

    span {
      color: #3A3A3A;
      margin-left: 5px;
    }
  }
  img {
    width: 280px;
    border-radius: 5px;
  }
  .bintright {
    text-align:right;
  }
}
</style>
